<template>
	<div class="d-flex align-items-center min-vh-100 overflow-hidden">
		<div class="container">
			<div class="row">
				<div class="col-md-4 offset-md-4">
					<div class="animate__animated animate__bounceIn">
						<div class="card shadow">
							<div class="card-body text-center">
								<div class="mb-2">
									<img src="@/assets/img/kmib-logo.png" class="w-25" />
								</div>
								<div class="mb-3">
									<strong>KMIB EDU Exam</strong>
								</div>
								<h4 class="mb-3">
									<strong>{{$t('header.login')}}</strong>
								</h4>
								<form @submit.prevent="onLoginSubmit()">
									<div class="mb-3">
										<input type="text" :placeholder="$t('placeholder.enter-password')" class="form-control form-control-lg text-center" style="-webkit-text-security: disc;" ref="password" v-model="password" required />
									</div>
									<div class="d-grid">
										<button type="submit" class="btn btn-lg btn-primary d-block" :disabled="btnLoginDisabled">{{$t('btn.login')}}</button>
									</div>
								</form>
								<div class="alert alert-warning alert-dismissible mt-3 mb-0 text-center" role="alert" v-if="errorLogin">
									{{errorLogin}}
									<button type="button" class="btn-close" aria-label="Close" @click="errorLogin = ''"></button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Авторизация | KMIB EDU Exam'});
	},
	data: () => ({
		password: '',
		
		errorLogin: '',
		btnLoginDisabled: false,
	}),
	methods: {
		async onLoginSubmit(){
			this.errorLogin = '';
			this.btnLoginDisabled = true;
			
			let res = await this.authModel.doLoginExam(this.password);
			
			this.btnLoginDisabled = false;
			if(res.success){
				this.$router.push('/');
			} else {
				this.errorLogin = res.error;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
		
		this.$refs.password.focus();
	},
	beforeMount(){
		document.body.classList.add('exam-bg');
	},
	beforeUnmount(){
		document.body.classList.remove('exam-bg');
	},
	beforeRouteUpdate(to, from, next){
		document.body.classList.add('exam-bg');
		window.scrollTo(0, 0);
		next();
	},
};
</script>